<template>
  <div class="clm-mob-text">
    <div class="clm-form-title">
      <slot></slot>
    </div>
    <a-line-text :line-type="lineType" @action="$emit('action')"/>
  </div>
</template>

<script>
import aLineText from './a-line-text.vue'
export default {
  name: "a-mob-text",
  components: {
    aLineText
  },
  props: {
    lineType: String,
  }
}
</script>